module.exports = __webpack_public_path__ + "VAGRoundedStd-Black.bc16795eb6ff2135d47a.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.ttf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.ttf
// module chunks = styles